import { gql, useMutation } from '@apollo/client'
import { path } from 'ramda'
import { useNotification } from '@btime/react-messager'
import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { accountsClient } from '../../utils/apollo/api'
import Editable from '../../packages/kiti/components/form/Editable'

const MUTATION = gql`
  mutation UpsertUser($input: UserInput) {
    upsertUser(input: $input) {
      id
    }
  }
`

const cleanRequest = (field, value) => {
  switch (field) {
    case 'group':
      return { groupId: value?.id }
    case 'profile':
      return { profileId: value?.id }
    default:
      return { [field]: value }
  }
}

const EditableUser = ({ record, field, children, ...props }) => {
  const canEdit = useSessionPermission('editUser')
  const notify = useNotification()
  const [request, { loading }] = useMutation(MUTATION, { refetchQueries: ['Users', 'User'], client: accountsClient })

  const handleRequest = value => {
    const params = { variables: { input: { id: record.id, ...cleanRequest(field, value) } } }
    return request(params).then(resp => {
      if (!!resp.errors) {
        notify.error({ title: 'Ocorreu um erro ao salvar!', message: path(['errors', 0, 'message'], resp) })
      }
    })
  }

  return (
    <Editable value={record[field]} onSubmit={handleRequest} loading={loading} disabled={!canEdit} {...props}>
      {children}
    </Editable>
  )
}

export default EditableUser
